<script>
    import R, {LOADER} from "../lib/js/requests";
    import {router} from '../lib/Router/Router.svelte';
    import {PAYMENT_TYPE} from "../lib/js/constants.js";
    import ContactPanel from "../lib/components/ContactPanel.svelte";
    import ReservationDetailsTable from "../book/ReservationDetailsTable.svelte";
    import BankPolicy from "../lib/components/BankPolicy.svelte";

    export let hash;

    let reservation = null;

    const load = () => {
        const onSuccess = result => {
            reservation = result;
        }

        const onFailure = err => {
            router.go("/not-found")();
        };

        R.handle(R.reservation.details, hash, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<section class="py-5">
    <div class="container">
        {#if reservation != null}
            <h1 class="mb-3">Your transfer booking was successful!</h1>
            {#if reservation.payment_type == PAYMENT_TYPE.CARD}
                <p class="mb-5">
                    You will receive an email shortly with your booking details.<br>
                    If you do not receive it, please <strong>check your spam folder</strong>.
                </p>
            {:else}
                <p class="mb-5">
                    Your booking is being processed, and we will contact you shortly.<br>
                    Within the next few hours, we will inform you of your booking cost and payment details.<br>
                    If you don’t hear back from us, please <strong>check your spam
                    folder</strong>.
                </p>
            {/if}
            <div class="row">
                <div class="col-xl-7 col-lg-6 mb-4">
                    <ReservationDetailsTable {reservation}/>
                </div>
                <div class="col-xl-5 col-lg-6">
                    {#if reservation.payment_type == PAYMENT_TYPE.BANK}
                        <BankPolicy/>
                    {/if}
                    <ContactPanel/>
                </div>
            </div>
        {/if}
    </div>
</section>